import { render } from "./ButtonAI.vue?vue&type=template&id=2b9908f2&scoped=true"
import script from "./ButtonAI.vue?vue&type=script&lang=js"
export * from "./ButtonAI.vue?vue&type=script&lang=js"

import "./ButtonAI.vue?vue&type=style&index=0&id=2b9908f2&lang=scss&scoped=true"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9908f2"]])

export default __exports__